import {CustomCheckbox} from "../../../../components/CustomCheckbox";
import SummaryItem from "./SummaryItem";
import {IconCardHexagon} from "../../../../components/buttons/IconButtons";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 30 de 04 de 2026
 */

const SummaryContainerRelay = ({data,t}) => {
    return (
        <div className={"row p-12px"}>
            <div className={"maxw-5 col-1 p-0 d-none d-md-block"}>
                <div className='background-primary-100 p-8px border-radius-8px d-flex justify-content-center
                align-items-center w-44px h-44px'>
                    <IconCardHexagon width={24} height={24}/>
                </div>
            </div>
            <div className={" col-12 col-md-11 row p-0"}>
            <div className={"col-12 col-md-6 gap-12px d-flex flex-column"}>
                <SummaryItem
                    label={'delay_to_open'}
                    value={data.delayToOpen}
                    t={t}
                />
            </div>
            <div className={"col-12 col-md-6 gap-12px d-flex flex-column"}>
                <SummaryItem
                    label={'keep_open_relay'}
                    value={data.keepOpenRelay}
                    t={t}
                />
            </div>
        </div>
      </div>
    )

}
export default SummaryContainerRelay
